import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAnnotationRejected = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 2,
			width: 20,
			height: 20,
			rx: 4,
			fill: "currentColor",
			fillOpacity: .18
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5 11C17.5 8.51472 15.4853 7 13 7H12.162C9.8365 7 8.67375 7 7.82311 7.75085C6.97246 8.5017 6.84449 9.52445 6.58856 11.57C6.53363 12.009 6.5 12.4147 6.5 12.75C6.5 14.5784 7.17157 15 9 15H13C15.4853 15 17.5 13.4853 17.5 11Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.8 13.6L15.1656 14.5307C15.6129 14.3551 15.8719 13.8861 15.7825 13.4139C15.6931 12.9418 15.2805 12.6 14.8 12.6V13.6ZM10.5 18H9.5C9.5 18.4847 9.84768 18.8997 10.325 18.9845C10.8022 19.0694 11.2716 18.7997 11.4387 18.3447L10.5 18ZM11.5 18C11.5 17.3915 11.6688 16.5094 12.1573 15.8102C12.6073 15.166 13.376 14.6 14.8 14.6V12.6C12.724 12.6 11.3427 13.4839 10.5177 14.6648C9.73121 15.7906 9.5 17.1085 9.5 18H11.5ZM10.5 18C11.4387 18.3447 11.4386 18.345 11.4385 18.3453C11.4384 18.3454 11.4383 18.3457 11.4383 18.3459C11.4381 18.3462 11.438 18.3466 11.4379 18.3468C11.4377 18.3474 11.4376 18.3477 11.4375 18.3479C11.4374 18.3482 11.4376 18.3478 11.438 18.3467C11.4388 18.3445 11.4408 18.3393 11.4439 18.3315C11.4501 18.3159 11.4607 18.2895 11.4761 18.2534C11.5068 18.1813 11.5561 18.0712 11.6253 17.9328C11.7641 17.6551 11.9804 17.2686 12.2845 16.8473C12.8968 15.9992 13.8319 15.0546 15.1656 14.5307L14.4344 12.6692C12.6313 13.3775 11.4164 14.6329 10.6629 15.6767C10.2841 16.2015 10.0136 16.6839 9.83627 17.0387C9.74739 17.2165 9.68126 17.3635 9.63613 17.4695C9.61355 17.5225 9.59617 17.5653 9.58378 17.5967C9.57758 17.6124 9.57263 17.6252 9.56889 17.635C9.56702 17.6399 9.56545 17.6441 9.56418 17.6475C9.56355 17.6492 9.56299 17.6507 9.56251 17.652C9.56227 17.6526 9.56204 17.6532 9.56184 17.6538C9.56174 17.6541 9.5616 17.6544 9.56155 17.6546C9.56141 17.6549 9.56128 17.6553 10.5 18Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgAnnotationRejected);
export { ForwardRef as ReactComponent };
